import moment from 'moment'

export default class DateUtil {
  static parse (dateString, format) {
    if (!dateString) {
      return null
    }
    return moment(dateString, format)
  }

  static format (date, format) {
    if (date == null) {
      return ''
    }
    return moment(date).format(format)
  }

  static changeFormat (dateString, srcFormat, dstFormat) {
    const date = this.parse(dateString, srcFormat)
    if (date == null) {
      return ''
    }

    return this.format(date, dstFormat)
  }
}



// WEBPACK FOOTER //
// ./src/utils/date.js